import {FC} from 'react'
import {KTIcon} from '../../../../_handld/helpers'
import {useListView} from '../jobs-list/core/ListViewProvider'

type Props = {
  data: any
}

const JobsEditModalHeader: FC<Props> = ({data}) => {
  const {setItemIdForUpdate} = useListView()

  return (
    <div className='modal-header'>
      {/* begin::Modal title */}
      <h2 className='fw-bolder'>Job details <span className='mx-5'>#{data?.code}</span></h2>
      {/* end::Modal title */}

      {/* begin::Close */}
      <div
        className='btn btn-icon btn-sm btn-active-icon-primary'
        data-kt-users-modal-action='close'
        onClick={() => setItemIdForUpdate?.(undefined)}
        style={{cursor: 'pointer'}}
      >
        <KTIcon iconName='cross' className='fs-1' />
      </div>
      {/* end::Close */}
    </div>
  )
}

export {JobsEditModalHeader}
